import { configurationMenus } from "./configuration"
import { cmsMenus } from "./content-management-system"
import { dbnCloudMenus } from "./dbn-cloud"
import { eAdvisorMenus } from "./eAdvisor"
import { eApplicationMenus } from "./eApplication"
import { operatorManagerMenus } from "./operator-manager"
import { organizationMenus } from "./organization"
import { policyMenus } from "./policy-manager"
import { routeManagerMenus } from "./route-management"
import { salesMenus } from "./sales"
import { serviceMenus } from "./service"
import { settingMenus } from "./setting"
import { smartBookingMenus } from "./smart-booking"
import { systemMenus } from "./system"
import { taxonomyMenus } from "./taxonomy"

export const menusData = () => {
    return ([
        eAdvisorMenus(),
        taxonomyMenus(),
        routeManagerMenus(),
        policyMenus(),
        operatorManagerMenus(),
        salesMenus(),
        smartBookingMenus(),
        cmsMenus(),
        dbnCloudMenus(),
        serviceMenus(),
        eApplicationMenus(),
        organizationMenus(),
        configurationMenus(),
        settingMenus(),
        systemMenus(),
    ])
}